import { render, staticRenderFns } from "./processRout.vue?vue&type=template&id=50bacef1&scoped=true&"
import script from "./processRout.vue?vue&type=script&lang=js&"
export * from "./processRout.vue?vue&type=script&lang=js&"
import style0 from "./processRout.vue?vue&type=style&index=0&id=50bacef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bacef1",
  null
  
)

export default component.exports